module.exports = __webpack_public_path__ + "OpenSans-Regular.a05c11bfc8ff02126f04.ttf";


//////////////////
// WEBPACK FOOTER
// C:/Users/jerd_/Documents/e-payment-public/e-payment-frontend/src/assets/customfonts/OpenSans-Regular.ttf
// module id = ../../../../../src/assets/customfonts/OpenSans-Regular.ttf
// module chunks = styles